import getDefaultComposeContentBlock from './getDefaultComposeContentBlock';
import convertInlineCss from 'roosterjs-editor-dom/lib/utils/convertInlineCss';
import { format } from 'owa-strings';
var SIGNATURE_ID = 'signature';
export default function createSignatureBlock(bodyType, fullSignature, isAutoSignature) {
    var signatureBlock = null;
    if (fullSignature) {
        if (bodyType == 'HTML') {
            // Create two lines of spaces above the signature and wrap signature with id='signature'.
            // Also, the empty two lines need to carry default format
            var defaultContentBlock = getDefaultComposeContentBlock();
            // The content from signature is wrapped within <html> and <body> tag
            // Let the content go through roosterjs.convertInlineCss
            // convertInlineCss does either of two things:
            // 1) do css inlining
            // Or
            // 2) remove the <html> and <body> wrapping when any global style is present
            // For here, we're mostly leveraging 2) since we don't have any global style in signature
            var signatureContent = convertInlineCss(fullSignature);
            // For the auto signature, we need to add two empty line
            // For the manual signature, since there is already "insert in new line" option, only need add one empty line
            // And the result is the same, there are two empty line above the signature.
            signatureBlock = isAutoSignature
                ? defaultContentBlock + defaultContentBlock
                : defaultContentBlock;
            signatureBlock += format("<div id='{0}'>{1}</div>", SIGNATURE_ID, signatureContent);
        }
        else {
            /* bodyType == "Text" */
            signatureBlock = '\n\n' + fullSignature;
        }
    }
    return signatureBlock;
}
//# sourceMappingURL=createSignatureBlock.js.map